/**
 * default filter product stock
 */
export const DEFAULT_FILTER_PRODUCT_STOCK_STOCK_AVAILABLE = 'stock_available';
export const DEFAULT_FILTER_PRODUCT_STOCK_ALMOST_OUT_STOCK = 'almost_out_stock';
export const DEFAULT_FILTER_PRODUCT_STOCK_OUT_STOCK = 'out_stock';
